import React, { memo, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import './Filter.scss';
import { Button } from 'components';
import { APP_STATUS } from 'shared/constants';

interface Props {
  onShowUpdatePopup: ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void) | undefined,
  filterBy,
  handleSelectFilter,
  searchText,
  handleSearchFilter,
  isDisabledPopup?: boolean,
}

const Filter: React.FC<Props> = ({
  onShowUpdatePopup, filterBy, handleSelectFilter, searchText, handleSearchFilter, isDisabledPopup = false,
}): JSX.Element => {
  const intl = useIntl();

  const ButtonGroup = [{
    name: APP_STATUS.ONGOING,
    value: 'dashboard.status.ongoing',
  }, {
    name: APP_STATUS.COMPLETED,
    value: 'dashboard.status.completed',
  }, {
    name: APP_STATUS.CANCELLED,
    value: 'dashboard.status.cancelled',
  }];

  const [isDisabledPopupState, setIsDisabledPopup] = useState(isDisabledPopup);

  useEffect(() => {
    if (isDisabledPopup !== isDisabledPopupState) {
      setIsDisabledPopup(isDisabledPopup);
    }
    // eslint-disable-next-line
  }, [isDisabledPopup]);

  // console.log('bbb', isDisabledPopup, 'ccc', isDisabledPopupState);

  return (
    <section className="filter">
      <article className="filter__search">
        <span />
        <input
          type="text"
          placeholder={intl.formatMessage({ id: 'dashboard.filter.searchByName' })}
          value={searchText}
          onChange={handleSearchFilter}
        />
      </article>
      <article className="filter__button">
        <Button
          isDisabled={isDisabledPopupState}
          value={intl.formatMessage({ id: 'dashboard.filter.updateAppStatus' })}
          onButtonClick={onShowUpdatePopup}
        />
        <small>
          {intl.formatMessage({ id: 'dashboard.filter.filter' })}
          :
          {' '}
        </small>
        {ButtonGroup.map((item, idx) => (
          <Button
            key={idx}
            name={item.name}
            onButtonClick={handleSelectFilter}
            value={intl.formatMessage({ id: item.value })}
            isOutline={!filterBy.includes(item.name)}
            isSecondary={filterBy.includes(item.name)}
          />
        ))}
      </article>
    </section>
  );
};

export default memo(Filter);
